export var gridVariables = function gridVariables() {
  return {
    defaultColumnCount: 5,
    gridGap: undefined,
    padding: undefined
  };
};